<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>설문조사 수정</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="survey_title">{{ $t('Survey.list.Survey Title') }}</label>
                        <InputText :class="`${error.sTitle ? 'p-invalid' : ''}`" type="text" :placeholder="$t('search.placeholder.search')" v-model="surveyTitle" />
                        <div class="text-red">{{ error.sTitle }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="survey_url">{{ $t('Survey.list.Survey URL') }}</label>
                        <InputText :class="`${error.link ? 'p-invalid' : ''}`" type="text" :placeholder="$t('search.placeholder.search')" v-model="SurveyURL" />
                        <div class="text-red">{{ error.link }}</div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('Survey.search.Start Date') }}</label>
                         <!-- :min-date="new Date(start_date)"
                            :manualInput="false" -->
                        <Calendar
                            :class="`${error.sDate ? 'p-invalid' : ''}`"
                            :showIcon="true"
                            :showButtonBar="true"
                            v-model="start_date"
                            dateFormat="yy.mm.dd"
                            :placeholder="$t('search.placeholder.date')"
                        ></Calendar>
                        <div class="text-red">{{ error.sDate }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('Survey.search.End Date') }}</label>
                        <Calendar :min-date="new Date(start_date)"
                            :manualInput="false" :class="`${error.eDate ? 'p-invalid' : ''}`" :showIcon="true" :showButtonBar="true" v-model="end_date" dateFormat="yy.mm.dd" :placeholder="$t('search.placeholder.date')"></Calendar>
                        <div class="text-red">{{ error.eDate }}</div>
                    </div>
                </div>
                <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                    <label for="exposure">{{ $t('Survey.list.Exposure') }}</label>
                    <div class="p-field p-col-12 p-md-3">
                        <!-- <InputSwitch trueValue="active" v-model="surveyStatus" /> -->
                        <InputSwitch v-model="surveyStatus" />
                        <!-- <div class="text-red">{{ error.title }}</div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-d-flex p-jc-between">
                <div>
                    <ConfirmPopup></ConfirmPopup>
                    <Button label="help" class="p-button-outlined p-button-help p-mr-2 p-mb-2" @click="confirm($event)"><i class="pi pi-check p-mr-2"></i>Save</Button>
                </div>
                <div>
                    <Button @click="$router.go(-1)" label="Go Back" class="p-button-outlined p-mr-2 p-mb-2" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/user/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import SurveyService from '../../service/API/SurveyService';
import AddSurvey from '../../validations/survey/AddSurvey';
import addDay from '../../mixin/mixinFunction';
// import axios from 'axios';
// import ProductService from '../service/ProductService';
// import axios from 'axios';
export default {
    mixins: [addDay],
    data() {
        return {
            selected: [],
            selectedItemss: '',
            render: true,
            display: false,
            position: 'center',
            visibleLeft: false,
            visibleRight: false,
            visibleTop: false,
            visibleBottom: false,
            visibleFull: false,

            customer1: null,
            loading1: false,
            idFrozen: false,
            products: null,
            expandedRows: [],
            user: null,
            error: {},
            //params for list
            surveyTitle: '',
            surveyStatus: false,
            SurveyURL: '',
            start_date: '',
            end_date: '',
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.surveyService = new SurveyService();
    },
    mounted() {
        this.getDetails();
    },
    watch: {},
    methods: {
        confirm(event) {
            this.$confirm.require({
                target: event.currentTarget,
                message: '계속 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    console.log(this.SurveyURL);
                    let vcheckData = {
                        sTitle: this.surveyTitle,
                        link: this.SurveyURL,
                        sDate: this.start_date !== '' ? 'something' : '',
                        eDate: this.end_date !== '' ? 'something' : '',
                    };
                    console.log(vcheckData);
                    const { isInvalid, error } = AddSurvey(vcheckData);
                    if (isInvalid) {
                        this.error = error;
                        console.log(error);
                    } else {
                        this.error = {};
                        this.surveyService.updateSurvey(this.surveyTitle, this.SurveyURL, this.addDay(this.start_date), this.addDay(this.end_date), this.surveyStatus == '' ? 'inactive' : 'active', this.$route.params.id).then(() => {
                            this.$toast.add({ severity: 'success', summary: 'Success', detail: '설문조사가 성공적으로 업데이트되었습니다.', life: 3000 });
                            setTimeout(() => {
                                this.$router.push({ name: 'surveyList' });
                            }, 1000);
                        });
                    }
                    // //callback to execute when user confirms the action
                    // this.surveyService.updateSurvey(this.surveyTitle, this.surveyURL, this.start_date, this.end_date, this.surveyStatus == true ? 'active' : 'inactive', this.$route.params.id).then(() => {
                    //     this.$router.push({ name: 'surveyList' });
                    // });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                },
            });
        },
        getDetails() {
            this.surveyService.survyDetails(this.$route.params.id).then((data) => {
                this.surveyTitle = data.survey_title;
                this.SurveyURL = data.survey_url;
                this.start_date = this.formatDate(data.start_date);
                this.end_date = this.formatDate(data.end_date);
                // alert(this.surveyStatus);
                if (data.status === 'active') {
                    this.surveyStatus = true;
                } else {
                    this.surveyStatus = false;
                }
            });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        resetUser() {
            this.name = '';
            this.email = '';
            this.mobile = '';
            this.error = {};
            this.calendarValue = '';
            this.calendarValue1 = '';
            this.userService.getUserList(this.name, this.email, this.mobile).then((data) => {
                this.customer1 = data;
                this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}
.p-fluid {
    .p-button {
        width: auto;
    }
}
</style>
